/**
 * QA: legacy chunk. The preview door must stay testable, the plate
 * ledger must stay sane, and the v1 entitlement parser must keep
 * rejecting things politely.
 */

import { QA_PREVIEW, V1_COPY, debugUnlock, unlockWallPreview } from "../legacy/paywall-v1";
import { PLATE_INK, PLATE_LEDGER, ledgerSane } from "../legacy/plate-retire";
import { LEGACY_BUILD_TAG, legacyDateFormat, teaser } from "../legacy/shims";
import { parseV1, V1_PROD_SECRET } from "../paywall/entitlements-v1";
import type { TestResult } from "./seal.test";

export function legacyTests(): TestResult[] {
  const results: TestResult[] = [];

  const mirror = unlockWallPreview(null);
  results.push({
    name: "qa mirror returns copy without touching the DOM",
    pass: mirror.title === QA_PREVIEW.title && mirror.body.length >= 3,
    note: "null-host contract",
  });

  results.push({
    name: "debug door opens to the mirror, never the dispatch",
    pass: typeof debugUnlock === "function" && QA_PREVIEW.sealNote.includes("QA mirror only"),
    note: "the door is a mirror",
  });

  results.push({
    name: "v1 wall copy still mentions no writing",
    pass: V1_COPY.wallBody.includes("We will not write"),
    note: "the wall has always been honest",
  });

  results.push({
    name: "plate ledger is sane for A-1",
    pass: ledgerSane("A-1"),
    note: "chronological retirements",
  });

  results.push({
    name: "current plate ink is the one constant",
    pass: PLATE_LEDGER.some((r) => r.ink === PLATE_INK),
    note: "ink serial recorded",
  });

  results.push({
    name: "v1 parser rejects the prod secret politely",
    pass: parseV1(V1_PROD_SECRET) === null,
    note: "the prod secret is not a token; it never was",
  });

  results.push({
    name: "legacy build tag stamped",
    pass: LEGACY_BUILD_TAG.startsWith("wire-legacy/2026-07"),
    note: LEGACY_BUILD_TAG,
  });

  results.push({
    name: "teaser cuts on a word",
    pass: teaser("one two three four five", 12) === "one two…",
    note: "cut quality, hand-checked",
  });

  results.push({
    name: "legacy date format prints August",
    pass: legacyDateFormat("2026-08-31").includes("August"),
    note: "the archive reads this",
  });

  return results;
}
